<script context="module" lang="ts">
  import type { Prompt } from '$routes/auth/account/_components/auth';
  import { writable } from 'svelte/store';

  export let isVisible = writable(false);

  type AuthModalParams = {
    flow: 'login' | 'create' | 'suit-up';
    redirectUrl: string | null;
    prompt: Prompt | null;
    callback: (() => Promise<void>) | (() => void) | null;
  };
  const selDefault: AuthModalParams = {
    flow: 'create',
    redirectUrl: null,
    prompt: null,
    // Default callback after closing the modal / terminating the flow
    callback: null
  };
  const sel = writable(selDefault);

  export function openAuthModal(params: {
    flow?: 'login' | 'create' | 'suit-up';
    redirectUrl?: string;
    prompt?: Prompt;
    callback?: (() => Promise<void>) | (() => void);
  }) {
    const defaultParams = { ...selDefault, ...params };
    sel.set(defaultParams);
    isVisible.set(true);
  }
</script>

<script lang="ts">
  import Modal from '$components/Modal.svelte';
  import Auth from '$routes/auth/account/_components/Auth.svelte';
</script>

<Modal
  bind:isVisible={$isVisible}
  portalTarget="body"
  limitHeight={false}
  modalZindex="z-higher-modal"
  backgroundZindex="z-higher-modal-backdrop"
  class="bg-ondark-base flex h-full pt-5 xl:max-h-[596px] xl:pt-0"
  widthClass="w-full xl:max-w-[960px]"
  overflow="overflow-visible"
  closeButtonClass="z-20"
  wrapperClass="fixed z-higher-modal"
  closeButton={$sel.flow !== 'suit-up'}
  closeOnClickOutside={$sel.flow !== 'suit-up'}
>
  <Auth
    variant="full"
    bind:flow={$sel.flow}
    callback={$sel.callback}
    redirectUrl={$sel.redirectUrl}
    prompt={$sel.prompt}
    switchHref={false}
    on:done={() => {
      isVisible.set(false);
      $sel = selDefault;
    }}
  />
</Modal>
